import {ID, Response} from '../../../../../../../_metronic/helpers'
export type User = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  username?: string
  firstname?: string
  lastname?: string
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type UsersQueryResponse = Response<Array<User>>

export const initialUser: User = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',
}

export interface IUsers {
  id?: ID
  uuid?: string
  username?: string
  firstname?: string
  lastname?: string
  email?: string
  password?: string
  confirm_password?: string
  device_name?: string
}

export const UsersInitValues: IUsers = {
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  confirm_password: '',
  device_name: '',
}

export interface Contracts {
  id?: ID
  uuid?: string
  identifier?: string  
  contract_type?: string
  measurement?: string
  start_contract?: string
  expiration_contract?: string
  property_id?: string
  project_id?: string
  payday?: string
  payment_month?: string
  effective_days?: string
  gross_value?: string
  base_IR?: string
  aliquot?: string
  deduction?: string
  income_tax?: string
  net_value?: string
  signed?: boolean
  observations?: string




  expiration_date?: string
  file?: string
  parent_id?: number[]

  description?: string
  license_number?: string
  issue_organ?: {
    name: string
  }

  issue_date?: string

  limit_renovation?: string
  status?: string

  licenseAlertDay?: [
    {
      id?: number
      renovation_alert_day?: number
    }
  ]

  fields?: [
    {
      name: string
      id: number
    }
  ]

  project?: {
    uuid?: string
    code: string
    id: number
  }

  license_type?: {
    abbreviate: string
  }

  licenseType?: {
  id: number
  abbreviate: string
  }

  entrepreneur?: {
    id: number
    name: string
  }
  enterprises?: [
    {
      id: number
      name: string
    }
  ]

 property?: {
  uuid?: string
  name: string
  id: number
  fields?: [
    {
      name: string
      id: number
    }
  ]

 }

 
}

export type ContractsQueryResponse = Response<Array<Contracts>>

export const ContractsInitValues: Contracts = {
  description: '',
}
